(function(){
    'use strict';

    angular.module('tmx-app')
        .directive('exportExcel', [exportExcel]);

    function exportExcel() {

        var directive={
            restrict: 'E',
            scope: {
                kendogrid: '=',
                enitityName:'@'
            },
            templateUrl: 'common/directives/exportexcel/exportexcel.html',
            controller: ["$scope","tmxUtility","$timeout",exportExcelCtrl],
       /* controller:function($scope){

        },*/
            controllerAs:'exportExcelCtrl'
        };
        return directive; 
    }

    function exportExcelCtrl($scope,tmxUtility,$timeout){
        var vm=this;
        vm.scope=$scope;
        var exists=tmxUtility.exists;

        vm.exportExcel=function(){
            if(exists(vm.scope.kendogrid)){
                vm.result=true;
                $timeout( function(){
                    vm.scope.kendogrid.saveAsExcel();
                    vm.result=false;
                }, 100 );
        
               
            }
        }
    }


})();